import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const EquipmentAssociatedSkeleton = () => (
  <tr>
    <td className={style.cellEquipmentName}>
      <SkeletonBlock className={style.skeletonText} />
    </td>
    <td>
      <SkeletonBlock className={style.skeletonText} />
    </td>
  </tr>
);

export default EquipmentAssociatedSkeleton;
